import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";

/**
 * The files attached to a wiki page. Read through the generic files API, which every member of the
 * organisation reads.
 */
export function useWikiPageFiles(pageId: string) {
	/** Query */
	const query = useQuery({
		queryKey: ["wiki-page-files", pageId],
		queryFn: async () => {
			const response = await client.files[":tableName"][":key"][":identifier"].$get({
				param: { tableName: "wikiPageFiles", key: "wikiPageId", identifier: pageId },
			});
			const data = await responseHandler(response);
			return data.files;
		},
	});

	/** Return */
	return { ...query, files: query.data ?? [] };
}
